module.exports = __webpack_public_path__ + "img/01010201.17119728.png";